import React from "react";
import { Mail } from "lucide-react";
import { StaticPage, Section, Bullets } from "../components/StaticPage";

export const Contact = () => (
  <StaticPage
    title="Contact Us"
    subtitle="We'd love to hear from you."
    testId="contact-page"
  >
    <p>
      If you have a question, suggestion, technical issue, privacy-related question, or concern
      regarding content or functionality on Absolute Cinema, you can contact us by email.
    </p>

    <a
      href="mailto:absolutecinema2503@gmail.com"
      className="ac-card inline-flex items-center gap-3 px-5 py-3 ac-gold-text hover:brightness-110 transition"
      data-testid="contact-email-link"
    >
      <Mail className="w-5 h-5" />
      absolutecinema2503@gmail.com
    </a>

    <Section heading="What You Can Contact Us About">
      <p>You can contact us regarding:</p>
      <Bullets items={[
        "General questions about Absolute Cinema",
        "Website feedback and suggestions",
        "Technical problems",
        "Website functionality",
        "Privacy-related questions or requests",
        "Copyright or intellectual-property concerns",
        "Other website-related issues",
      ]} />
    </Section>

    <Section heading="Copyright and Intellectual-Property Concerns">
      <p>
        If you are a copyright or intellectual-property rights holder and believe that material
        associated with Absolute Cinema infringes your rights, please contact us at the email
        address above.
      </p>
      <p>Please provide:</p>
      <Bullets items={[
        "The relevant page or location of the material",
        "A description of the material or issue",
        "Information that helps us understand your concern",
        "Your preferred contact information for follow-up",
      ]} />
      <p>We will review legitimate concerns and take appropriate action where necessary.</p>
    </Section>
  </StaticPage>
);
